module.exports = __webpack_public_path__ + "static/media/feedback_1.5a455a96.png";